import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AppExternalService } from '@commons/core/ui/app-external.service';

import { UntilDestroy, untilDestroyed } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'cng-front-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  @ViewChild('appExternalContainer', { static: true })
  private readonly appExternalContainer: any;

  constructor(private readonly renderer: Renderer2, private readonly appExternalService: AppExternalService) {}

  ngOnInit(): void {
    // renderer external frame
    this.appExternalService
      .applicationAdded$()
      .pipe(untilDestroyed(this))
      .subscribe(iframe => this.renderer.appendChild(this.appExternalContainer.nativeElement, iframe));
  }
}
